import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';
import PropTypes from 'prop-types';
import './style.scss';

export default function AutoCompleteInput(props) {
	const { trigger, onSelect, regex, spacer, spaceRemovers, value, maxOptions, options, placeholder, onChange } = props;

	return (
		<>
			<TextInput
				trigger={trigger}
				options={options}
				placeholder={placeholder}
				maxOptions={maxOptions}
				spaceRemovers={spaceRemovers}
				spacer={spacer}
				value={value}
				onSelect={onSelect}
				regex={regex}
				className='autocomplete-input__text'
				onChange={onChange}
			/>
		</>
	);
}

AutoCompleteInput.propTypes = {
	trigger: PropTypes.string,
	regex: PropTypes.string,
	value: PropTypes.any,
	spacer: PropTypes.string,
	placeholder: PropTypes.string,
	spaceRemovers: PropTypes.array,
	maxOptions: PropTypes.number,
	options: PropTypes.array,
	onChange: PropTypes.func,
	onSelect: PropTypes.func
};

AutoCompleteInput.defaultProps = {
	trigger: '@',
	regex: '^[a-zA-Z0-9-_]+$',
	spacer: ' ',
	spaceRemovers: [',', '.', '!', '?'],
	maxOptions: 6,
	options: [],
	value: '',
	placeholder: 'Enter',
	onSelect: () => {},
	onChange: () => {}
};
